export const actions = {
  set: 'SET::SITE',
  setNearestSites: 'SET::NEAREST_SITES_OBJECT'
}

export const setSite = site => ({ type: actions.set, site })
export const setClosestSites = sites => ({ type: actions.setNearestSites, sites })

export default actions
